export const Config = {
  AuthBaseURL: "/authentication-service",
  ACLBaseURL: "/acl-service",
  IdentityToken: "YXBwOkRfOTRjcw==",
  DataImportURL: "/data-import-service",
  PositionMngURL: "/position-service",
  EmpServiceURL: "/employee-service",
  ProjectServiceURL: "/project-service",
  PositionServiceURL: "/position-service",
  ActivityServiceURL: "/activity-service",
  ICPServiceURL: "/icp-service",
  NotificationService: "/notification-service",
};
